import { Row, Col, Form, Button, Spinner } from 'react-bootstrap';

function LocationSelector({
  accessLevel,
  locationData,
  loadingLocations,
  selectedProvinces, setSelectedProvinces,
  selectedDistricts, setSelectedDistricts,
  selectedDivisions, setSelectedDivisions,
}) {
  const getAllDistricts         = () => Object.values(locationData.districts || {}).flat();
  const getDistrictsForProvince = () => selectedProvinces.flatMap(pc => locationData.districts[pc] || []);
  const getDivisionsForDistrict = () => selectedDistricts.flatMap(dc => locationData.divisions[dc] || []);

  const toggle = (setter, code) =>
    setter(prev => prev.includes(code) ? prev.filter(c => c !== code) : [...prev, code]);

  const CheckboxGrid = ({ items, selected, onToggle, idPrefix }) => (
    <div className="um-checkbox-grid">
      {items.map(item => (
        <Form.Check
          key={item.code}
          type="checkbox"
          id={`${idPrefix}-${item.code}`}
          label={item.name}
          checked={selected.includes(item.code)}
          onChange={() => onToggle(item.code)}
        />
      ))}
    </div>
  );

  if (accessLevel === 'province') {
    return (
      <div className="um-location-section">
        <div className="um-location-label"><i className="bi bi-geo-alt me-1"></i>Select Provinces</div>
        {loadingLocations ? (
          <div className="text-center py-3"><Spinner animation="border" size="sm" /></div>
        ) : (
          <CheckboxGrid
            items={locationData.provinces || []}
            selected={selectedProvinces}
            onToggle={code => toggle(setSelectedProvinces, code)}
            idPrefix="prov"
          />
        )}
        <div className="um-selection-count">{selectedProvinces.length} selected</div>
      </div>
    );
  }

  if (accessLevel === 'district') {
    return (
      <div className="um-location-section">
        <div className="um-location-label"><i className="bi bi-geo-alt me-1"></i>Select Districts</div>
        {loadingLocations ? (
          <div className="text-center py-3"><Spinner animation="border" size="sm" /></div>
        ) : (
          <CheckboxGrid
            items={getAllDistricts()}
            selected={selectedDistricts}
            onToggle={code => toggle(setSelectedDistricts, code)}
            idPrefix="dist"
          />
        )}
        <div className="um-selection-count">{selectedDistricts.length} selected</div>
      </div>
    );
  }

  if (accessLevel === 'dsd') {
    const divisions = getDivisionsForDistrict();
    return (
      <>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="um-field-label">
                <span className="um-step-badge">1</span> Province
              </Form.Label>
              <Form.Select
                value={selectedProvinces[0] || ''}
                onChange={e => {
                  setSelectedProvinces(e.target.value ? [e.target.value] : []);
                  setSelectedDistricts([]);
                  setSelectedDivisions([]);
                }}
              >
                <option value="">— Select Province —</option>
                {(locationData.provinces || []).map(p => (
                  <option key={p.code} value={p.code}>{p.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label className="um-field-label">
                <span className="um-step-badge">2</span> District
              </Form.Label>
              <Form.Select
                value={selectedDistricts[0] || ''}
                disabled={!selectedProvinces.length}
                onChange={e => {
                  setSelectedDistricts(e.target.value ? [e.target.value] : []);
                  setSelectedDivisions([]);
                }}
              >
                <option value="">— Select District —</option>
                {getDistrictsForProvince().map(d => (
                  <option key={d.code} value={d.code}>{d.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {selectedDistricts.length > 0 && (
          <div className="um-location-section">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className="um-location-label mb-0">
                <span className="um-step-badge me-1">3</span> DS Divisions
              </div>
              <div className="d-flex gap-2">
                <Button variant="outline-primary" size="sm"
                  onClick={() => setSelectedDivisions(divisions.map(d => d.code))}>
                  Select all
                </Button>
                <Button variant="outline-secondary" size="sm" onClick={() => setSelectedDivisions([])}>
                  Clear
                </Button>
              </div>
            </div>
            <CheckboxGrid
              items={divisions}
              selected={selectedDivisions}
              onToggle={code => toggle(setSelectedDivisions, code)}
              idPrefix="dsd"
            />
            <div className="um-selection-count">{selectedDivisions.length} selected</div>
          </div>
        )}
      </>
    );
  }

  return null;
}

export default LocationSelector;
